import styled from 'styled-components';

export const LangChangerSC = styled.select`
          border: none;
         margin:0px;
         padding:0px;
         background-color:#f1f1f1;
        @media screen and (max-width:1000px){
       /* display:none; */
      }
        cursor:pointer;
          option {
  
            /* padding: 10px; */
          }
          .options {
            /* padding: 10px; */
          }
          &:hover {
            border: none;
          }
          &:focus {
            border: none;
            outline: none;
          }
`